import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { theme } from '../../themes/theme';
const baseStyles = css `
  text-decoration: ${({ disabled }) => (disabled ? 'none' : 'underline')};
  cursor: ${({ disabled }) => disabled && 'default'};
  color: ${({ disabled }) => (disabled ? 'gray' : theme.palette.primary.main)};
`;
export const ExternalArrowLink = styled.a `
  ${baseStyles}
`;
export const InternalLink = styled(Link) `
  ${baseStyles}
  padding-left: ${({ nopaddingleft }) => nopaddingleft === 'false' && '0.7em'};
`;
export const ExternalLink = styled.a `
  ${baseStyles}
  display:${({ hasMaxWidth }) => (hasMaxWidth ? 'flex' : undefined)};
  padding-left: ${({ nopaddingleft }) => nopaddingleft === 'false' && '0.7em'};
  ${({ disabled }) => !disabled &&
    `:after {
    content: url("data:image/svg+xml,%3Csvg width='8' height='8' viewBox='0 0 8 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m4.826,2.824l-2.826,-2.824l6,0l0,6l-2.467,-2.467l-4.826,4.826l-0.707,-0.708l4.826,-4.826l0,-0.001z' fill='%233f18aa' fill-rule='evenodd'/%3E%3C/svg%3E");
    padding-left: 0.15rem;
  }`};
`;
export const ThreeDotsDiv = styled.div `
  max-width: ${({ maxWidth }) => maxWidth};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
